// src/components/quotes/ConnaraQuote.js
import React from 'react';
import './ConnaraQuote.css';

export default function ConnaraQuote() {
  return (
    <div className="connara-quote-container">
      <h1>건설나라 견적·계약 플랫폼 기획서</h1>

      <section>
        <h2>1. 프로젝트 개요</h2>
        <ul>
          <li><strong>목표:</strong> 건설·건축 의뢰인과 시공사를 연결하는 안전·투명 <strong>견적-계약 올인원 플랫폼</strong> 구축</li>
          <li><strong>개발 방식:</strong> ① 기존 <strong>건설나라</strong> 인프라 활용 “확장형” ② 완전 신규 <strong>SaaS</strong> 구축 — 두 안 병행 검토</li>
        </ul>
      </section>

      <section>
        <h2>2. 기능 범위</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>영역</th>
                <th>개선 핵심</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>회원가입·업체 등록</strong></td>
                <td>사업자번호 실명인증 API, 관리자 1-click 승인</td>
              </tr>
              <tr>
                <td><strong>견적 요청·교환</strong></td>
                <td>표준 견적서 템플릿 + 실시간 채팅, 모든 파일·버전 자동 보존</td>
              </tr>
              <tr>
                <td><strong>전자계약</strong></td>
                <td>표준 계약서 자동 생성, 휴대폰 간편인증 전자서명, KISA 보관소 연동</td>
              </tr>
              <tr>
                <td><strong>제휴업체 마케팅</strong></td>
                <td>업체 미니페이지·갤러리·리뷰, AI 추천노출</td>
              </tr>
              <tr>
                <td><strong>AI 어시스트</strong></td>
                <td>① 견적 비교 AI ② 계약 위험 탐지 AI</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2>3. 4개월 로드맵 (8 스프린트)</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>월</th>
                <th>산출물</th>
                <th>주요 작업</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>M0 (주 1-2)</strong></td>
                <td>Kick-off & 설계 결정</td>
                <td>건설나라 API·DB 분석 vs 신규 SaaS 장단점 보고, 기술 스택 확정</td>
              </tr>
              <tr>
                <td><strong>M1 (주 3-6)</strong></td>
                <td><strong>MVP α</strong></td>
                <td>회원가입·실명인증·업체등록, 견적서 템플릿·채팅, 전자계약 초안</td>
              </tr>
              <tr>
                <td><strong>M2 (주 7-10)</strong></td>
                <td><strong>MVP β + AI 1차</strong></td>
                <td>견적 비교 AI, 계약 Risk Detector, Admin 대시보드</td>
              </tr>
              <tr>
                <td><strong>M3 (주 11-14)</strong></td>
                <td>마케팅·추천</td>
                <td>업체 미니페이지·리뷰, AI 추천노출, 수수료 정산</td>
              </tr>
              <tr>
                <td><strong>M4 (주 15-17)</strong></td>
                <td>보안·UAT·런칭</td>
                <td>WAF·DB 암호화, UAT·버그 픽스, 정식 오픈 & 운영 인수</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2>4. 팀 / 예산 (총 3,000 만원, VAT 별도)</h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>역할</th>
                <th>투입 MM</th>
                <th>단가(만원)</th>
                <th>금액</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>PM/PO</td><td>1.0</td><td>500</td><td>500</td></tr>
              <tr><td>FE Dev</td><td>1.5</td><td>550</td><td>825</td></tr>
              <tr><td>BE Dev</td><td>1.5</td><td>550</td><td>825</td></tr>
              <tr><td>ML/AI</td><td>0.8</td><td>600</td><td>480</td></tr>
              <tr><td>DevOps·보안</td><td>0.4</td><td>600</td><td>240</td></tr>
              <tr><td>QA</td><td>0.3</td><td>400</td><td>120</td></tr>
              <tr>
                <td><strong>합계</strong></td>
                <td><strong>5.5</strong></td>
                <td></td>
                <td><strong>2,990</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2>5. <strong>핵심 모듈 & 기술 스택 예시 (변동가능)</strong></h2>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>모듈</th>
                <th>주요 기능</th>
                <th>Back-/Infra</th>
                <th>Front</th>
                <th>AI·데이터</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>회원가입·업체등록</td>
                <td>사업자번호 실명인증, 중복 차단, 관리자 승인</td>
                <td>FastAPI + PostgreSQL, Firebase Auth</td>
                <td>Next.js (React)</td>
                <td>—</td>
              </tr>
              <tr>
                <td>견적 요청·채팅</td>
                <td>견적 템플릿, 도면·사진 첨부, 버전 관리</td>
                <td>WebSocket (Socket.io), S3 + GridFS</td>
                <td>Next.js Chat UI</td>
                <td>—</td>
              </tr>
              <tr>
                <td>전자계약</td>
                <td>표준 계약서 자동작성, 상태 타임라인, 간편인증 서명</td>
                <td>Docusign-like API, JSON→PDF, TSA 서버</td>
                <td>Vue PDF Renderer (React Wrapper)</td>
                <td>계약 텍스트 로그 수집</td>
              </tr>
              <tr>
                <td>Quote Comparer AI</td>
                <td>가격·기간·품질 스코어링, 레이더 차트</td>
                <td>REST Microservice (Python)</td>
                <td>React Charts</td>
                <td>OpenAI API/Fine-Tuning, Scikit-learn, LangChain, Phi3, DeepSeek</td>
              </tr>
              <tr>
                <td>Contract Risk Detector</td>
                <td>선금·지체상금·책임 불균형 탐지, 위험 배지</td>
                <td>FastAPI NLP Service</td>
                <td>React Banner</td>
                <td>spaCy + Rule Engine</td>
              </tr>
              <tr>
                <td>업체 미니페이지·리뷰</td>
                <td>사진/동영상 갤러리, 별점·댓글</td>
                <td>FastAPI REST, CDN</td>
                <td>Next.js Gallery·Review Components</td>
                <td>Elasticsearch Vector Search (추천)</td>
              </tr>
              <tr>
                <td>AI 추천노출</td>
                <td>위치·카테고리·평점 기반 랭킹</td>
                <td>Elasticsearch k-NN, Redis Cache</td>
                <td>React Swiper</td>
                <td>학습 피처 스토어 (Feature Store)</td>
              </tr>
              <tr>
                <td>모니터링·보안</td>
                <td>CI/CD, WAF, 로그·알람</td>
                <td>GitHub Actions, AWS EKS, Datadog</td>
                <td>—</td>
                <td>—</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2>6. “건설나라 확장” vs “신규 구축” (요약 비교)</h2>
        <div className="table-container">
          <table>
            <thead><tr><th>항목</th><th>확장 안 (A)</th><th>신규 안 (B)</th></tr></thead>
            <tbody>
              <tr><td>초기 개발 속도</td><td>빠름 (재사용)</td><td>인프라 세팅 필요</td></tr>
              <tr><td>커스터마이징</td><td>제한적</td><td>비교적 유연</td></tr>
              <tr><td>운영비용</td><td>기존 플랫폼 사용료 유지</td><td>AWS/Firebase 비용 발생</td></tr>
              <tr><td>장기 확장성</td><td>제한적일 가능성</td><td>확장 용이</td></tr>
              <tr><td>추천 시나리오</td><td>기존 고객 기반 많음</td><td>차별화 서비스 필요</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2>7. 계약·지급 조건</h2>
        <div className="table-container">
          <table>
            <thead><tr><th>구분</th><th>지급 시점</th><th>금액</th></tr></thead>
            <tbody>
              <tr><td><strong>계약금</strong></td><td>계약 체결 즉시</td><td>전체의 <strong>40%</strong></td></tr>
              <tr><td><strong>중도금</strong></td><td>계약금 지급 + 3주</td><td>전체의 <strong>40%</strong></td></tr>
              <tr><td><strong>잔금</strong></td><td>중도금 지급 + 5주</td><td>전체의 <strong>20%</strong></td></tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2>8. 지식재산권</h2>
        <p>
          지식재산권 귀속: 본 프로젝트를 통해 완성된 결과물(제품 정보 DB, 관리자 대시보드, 사용자 UI 등)은 건설나라에 귀속되며, 단, 본 용역 과정에서 활용되거나 개발된 AI 모델 연동 아키텍처, 자체 LLM API 처리 방식(A2A 연동 등)과 같은 범용 기술 및 모듈은 아케인즈의 고유 기술로서 해당 기술에 대한 소유권과 지식재산권은 아케인즈에 귀속되어 있습니다. (범용 기술은 MIT License와 같은 오픈소스 라이센스에 따라 적용됩니다.)
        </p>
      </section>
    </div>
  );
}
